import { render, staticRenderFns } from "./ZoneItems.vue?vue&type=template&id=713c05b2&"
import script from "./ZoneItems.vue?vue&type=script&lang=ts&"
export * from "./ZoneItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports